const white = "#fffffe";
const black = "#2d334a";
const lightTeal = "#e3f6f5";
const darkTeal = "#bae8e8";
const yellow = "#ffd803";
const red = "#f25042";

const theme = {
  background: white,
  text: black,
  color: {
    primary: white,
    secondary: lightTeal,
    tertiary: darkTeal,
    highlight: yellow,
    danger: red
  }
};

export default theme;
